<button class="btn-back" (click)="voltar()">
  <i class="fa fa-arrow-left"></i>
</button>
